// Prix de base des modules principaux (CAD/mois) par niveau
export const BASE_PRICES = {
  punch: { name: "PROGÈRE PUNCH", starter: 79, pro: 199, enterprise: 399 },
  crm: { name: "PROGÈRE CRM", starter: 69, pro: 149, enterprise: 299 },
  erp: { name: "PROGÈRE ERP", starter: 129, pro: 299, enterprise: 599 },
  compta: { name: "PROGÈRE COMPTA", starter: 79, pro: 199, enterprise: 399 },
  "devis-ai": { name: "PROGÈRE DEVIS AI", starter: 99, pro: 249, enterprise: 499 },
};

export const PAIE_ADDON = { name: "PROGÈRE PAIE", starter: 49, pro: 99, enterprise: 149 };
export const TAKEOFF_ADDON = { name: "PROGÈRE TAKEOFF", starter: 129, pro: 299, enterprise: 599 };

export const MAIN_MODULES = Object.keys(BASE_PRICES);
export const CONSTRUCTION_MODULES = ["erp", "compta"];
export const TAKEOFF_CONSTRUCTION = true;

export const LEVELS = [
  { key: "starter", label: "Starter" },
  { key: "pro", label: "Pro" },
  { key: "enterprise", label: "Entreprise" },
];

export function discountForCount(count) {
  if (count >= 4) return 20;
  if (count === 3) return 15;
  if (count === 2) return 10;
  return 0;
}

export const DISCOUNT_TABLE = [
  { count: "1 module", discount: "0 %", example: "PUNCH seulement = 79 $/mois" },
  { count: "2 modules", discount: "10 %", example: "PUNCH + CRM Starter = 133,20 $/mois" },
  { count: "3 modules", discount: "15 %", example: "PUNCH + ERP + DEVIS AI Starter = 260,95 $/mois" },
  { count: "4 modules et plus", discount: "20 %", example: "PUNCH + CRM + ERP + DEVIS AI Starter = 300,80 $/mois" },
  { count: "PROGÈRE 360", discount: "Sur demande", example: "Écosystème complet personnalisé" },
];

export const EXAMPLE_PACKS = [
  { title: "Pack Gestion Starter", modules: ["PROGÈRE PUNCH Starter", "PROGÈRE CRM Starter"], regular: "79 $ + 69 $ = 148 $/mois", discount: "10 %", final: "133,20 $/mois", saving: "14,80 $/mois", text: "Idéal pour une petite entreprise qui veut gérer ses employés et ses clients au même endroit." },
  { title: "Pack Chantier Starter", modules: ["PROGÈRE PUNCH Starter", "PROGÈRE ERP Starter", "PROGÈRE DEVIS AI Starter"], regular: "79 $ + 129 $ + 99 $ = 307 $/mois", discount: "15 %", final: "260,95 $/mois", saving: "46,05 $/mois", text: "Idéal pour gérer les heures, les projets et les soumissions dans un seul écosystème." },
  { title: "Pack Administration Starter", modules: ["PROGÈRE CRM Starter", "PROGÈRE COMPTA Starter"], regular: "69 $ + 79 $ = 148 $/mois", discount: "10 %", final: "133,20 $/mois", saving: "14,80 $/mois", text: "Idéal pour gérer les clients et la facturation au même endroit. Le support est inclus gratuitement." },
  { title: "Pack Construction Starter", modules: ["PROGÈRE PUNCH Starter", "PROGÈRE ERP Starter", "PROGÈRE DEVIS AI Starter", "Extra PROGÈRE TAKEOFF Starter"], regular: "79 $ + 129 $ + 99 $ + 129 $ = 436 $/mois", discount: "15 %", final: "370,60 $/mois", saving: "65,40 $/mois", text: "Idéal pour gérer ses heures, ses projets et ses soumissions avec quantités (TAKEOFF ajouté en option à DEVIS AI)." },
  { title: "Pack Compta + Paie Starter", modules: ["PROGÈRE COMPTA Starter", "Extra PROGÈRE PAIE Starter"], regular: "79 $ + 49 $ = 128 $/mois", discount: "Aucun", final: "128 $/mois", saving: "—", text: "Idéal pour ajouter la gestion de la paie directement dans PROGÈRE COMPTA." },
  { title: "Pack Administration + Paie Starter", modules: ["PROGÈRE CRM Starter", "PROGÈRE COMPTA Starter", "Extra PROGÈRE PAIE Starter"], regular: "69 $ + 79 $ + 49 $ = 197 $/mois", discount: "10 %", final: "177,30 $/mois", saving: "19,70 $/mois", text: "Idéal pour gérer les clients, la comptabilité et la paie dans le même environnement. Le support est inclus gratuitement." },
];

export function fmt(n) {
  return n.toLocaleString("fr-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " $";
}
